import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Text } from '../Text';
import styles from '@dtsl/css-progress-bar/dist/index.module.css';
function ProgressBar(props) {
  const {
    label,
    value,
    variant,
    size,
    specificationText,
    showPercentage,
    className
  } = props;
  const progressBarClasses = classNames({
    [styles['sib-progress-bar']]: true,
    [className]: !!className
  });
  const trackClasses = classNames({
    [styles['sib-progress-bar__track']]: true,
    [styles[`sib-progress-bar__track--${size}`]]: true
  });
  const indicatorClasses = classNames({
    [styles['sib-progress-bar__indicator']]: true,
    [styles[`sib-progress-bar__indicator--${variant}`]]: true
  });
  const progressValue = () => {
    if (typeof value !== 'number' || value < 0) {
      return 0;
    } else if (value > 100) {
      return 100;
    }
    return value;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: progressBarClasses
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['sib-progress-bar__label']
  }, /*#__PURE__*/React.createElement("div", null, label ? /*#__PURE__*/React.createElement(Text, null, " ", label, " ") : null), showPercentage ? /*#__PURE__*/React.createElement("span", {
    className: styles['sib-progress-bar__status']
  }, progressValue(), "%") : null), /*#__PURE__*/React.createElement("div", {
    role: "progressbar",
    "aria-valuenow": value,
    "aria-valuemin": "0",
    "aria-valuemax": "100",
    className: trackClasses
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['sib-progress-bar__progress'],
    style: {
      width: `${progressValue()}%`
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: indicatorClasses
  }))), specificationText ? /*#__PURE__*/React.createElement(Text, {
    size: "sm",
    color: "var(--sib-color_content-secondary)",
    className: styles['sib-progress-bar__helpText']
  }, specificationText) : null);
}
ProgressBar.defaultProps = {
  label: '',
  size: 'md',
  specificationText: '',
  showPercentage: true,
  className: ''
};
ProgressBar.propTypes = {
  label: PropTypes.string,
  value: PropTypes.number.isRequired,
  variant: PropTypes.oneOf(['info', 'warning', 'positive', 'negative']),
  size: PropTypes.oneOf(['sm', 'md']),
  specificationText: PropTypes.string,
  showPercentage: PropTypes.bool,
  className: PropTypes.string
};
export default ProgressBar;